module.exports = __webpack_public_path__ + "static/media/domino-frenzy.19d9b13f.png";